import {
    GET_CENTRAL_ORDERS_LOG_SUCCESS, GET_BRAND_AND_REST_NAMES
} from '../../actions/types';

const INITIAL_STATE = {
    orders: {},
    brandNames: [],
    restaurantNames: []
};

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case GET_CENTRAL_ORDERS_LOG_SUCCESS:
            return { ...state, orders: payload };
        case GET_BRAND_AND_REST_NAMES:
            return {
                ...state,
                brandNames: payload.brandNames,
                restaurantNames: payload.restaurantNames
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/central/CentralOrdersLogReducer.js